// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import VueSilentbox from 'vue-silentbox'
import VueHead from 'vue-head'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('v-icon', Icon)
Vue.use(VueHead)
Vue.use(VueSilentbox)
Vue.use(VueI18n)
Vue.config.productionTip = false

let i18n = new VueI18n({
  locale: 'fi' // set locale
})

//  uncomment when site goes multilingual again
//
// if (localStorage.locale) {
//   i18n.locale = localStorage.getItem('locale')
// } else {
//   localStorage.setItem('locale', i18n.locale)
// }
localStorage.setItem('locale', 'fi')
localStorage.setItem('last', 1)
i18n.locale = 'fi'
/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js